import { getServerInfo } from '../utils/helpers/networkInfo.helper'
import { post } from './api'

export function cycleLoadPDU({ host, username, password, port, load }, token) {
  const serverUrl = getServerInfo('api')
  const url = `${serverUrl}pdu-cycle-load`
  const data = {
    host,
    username,
    password,
    port,
    load,
  }

  return post(url, data, true, token)
}

export function setStateLoadPDU({ host, username, password, port, load, state }, token) {
  const serverUrl = getServerInfo('api')
  const url = `${serverUrl}pdu-set-state-load`
  const data = {
    host,
    username,
    password,
    port,
    load,
    state,
  }

  return post(url, data, true, token)
}

export function showStateLoadPDU({ host, username, password, port, load }, token) {
  const serverUrl = getServerInfo('api')
  const url = `${serverUrl}pdu-show-state-load`
  const data = {
    host,
    username,
    password,
    port,
    load,
  }

  return post(url, data, true, token)
}

export function clearLinePDU({ host, username, password, line_number }, token) {
  const serverUrl = getServerInfo('pdu')
  const url = `${serverUrl}cisco/clear-line`
  const data = {
    host,
    username,
    password,
    line_number,
  }

  return post(url, data, true, token)
}
